import { createSlice } from "@reduxjs/toolkit";
import { patientProfileDocumentAction } from "app/store/patientProfile/documents/actions/patientProfileDocumentAction";

export const initialState = {
  isLoading: false,
  isUploadModalOpen: false,
  isDocumentTableLoading: false,
  letterTemplates: [],
  isDownloading: false,
  showPreview: false,
  noShowPreview: false,
  file: {
    url: "",
    type: "",
  },
  isFileLoading: false,
  isLetterTemplateMenu: false,
  isNoShowLetterMenu: false,
  showDownloadTemplate: false,
  showBatteryInformationModal: false,
  batteryInformation: {},
  generatedLetterFilePath: null,
  selectedDocument: {},
  selectedTemplate: null,
  showPreviewMode: false,
  isDocumentTableRefresh: false,
  downloadingModalText: "Downloading...",
  isSendingSuccess: false,
  showNoShowEmailModal: false,
  letterNextSendDate: true,
  showLetterNextSendDateModal: false,
  pendingBatteryLife: null,
};

const patientProfileDocumentSlice = createSlice({
  name: "patientProfileDocument",
  initialState: initialState,
  reducers: patientProfileDocumentAction,
});

export const {
  setIsUploadModalOpen,
  setIsDocumentsLoading,
  setIsDocumentTableLoading,
  setIsDownloading,
  setShowPreview,
  setNoShowLetterPreview,
  setShowNoShowEmailModal,

  setIsFileLoading,
  setIsLetterTemplateMenu,
  setIsNowShowLetterMenu,
  setShowDownloadTemplate,
  setShowBatteryInformationModal,

  setShowPreviewMode,
  setDownloadingModalText,
  setIsDocumentTableRefresh,
  setSelectedTemplate,
  setSelectedDocument,

  setBatteryInformation,
  setGeneratedLetterFilePath,
  setIsSendingLetter,
  setFile,
  setIsSendingSuccess,
  setLetterNextSendDate,
  setLetterNextSendDateModal,
  setPendingBatteryLife,
} = patientProfileDocumentSlice.actions;

export default patientProfileDocumentSlice.reducer;
